import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from 'react-bootstrap';

const SearchInput = ({ placeholder, onKeyUp }) => (
  <div className="float-left position-relative">
    <FontAwesomeIcon
      className="position-absolute"
      style={{
        left: '12px',
        top: '10px'
      }}
      color="var(--gray-light)"
      icon="search"
    />
    <Form.Control
      type="text"
      name="search"
      className="pl-5"
      placeholder={placeholder}
      onKeyUp={onKeyUp}
    />
  </div>
);

SearchInput.defaultProps = {
  placeholder: 'Search...'
};

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  onKeyUp: PropTypes.func.isRequired
};

export default SearchInput;
